import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
  `<div>
  <p><strong>Description</strong></p>
  <p>
      This alert generates each Sunday morning at 10:30 AM PST. This alert evaluates the last two-weeks of stow data to identify associates with Standard Work opportunities and surfaces alerts in SCC's Work-items Tab. It has an SLA of 6
      days from generation. After the manager delivers the coaching and clicks the DONE button, another alert for that same stower will not be raised for the next 7 days.
  </p>
  <p><strong>Resolution Steps</strong></p>
  <p>
      1) AMZL Delivery Stations please Complete the
      <span className="wikiexternallink">
          <a
              href="https://d2r197ryfjzbxi.cloudfront.net/Content+and+Design+Team/GCA+F2F+Apps/Quality/Smart+Stow/EN/story.html"
              data-toggle="tooltip"
              data-placement="top"
              title=""
              rel="nofollow noreferrer noopener"
              data-original-title="Warning: This is an external link to d26wfe7v40mam2.cloudfront.net"
          >
              Stow Standard Work Coaching
          </a>
      </span>
      ; SSD Sites please Complete the
      <span className="wikiinternallink">
          <a
              href="https://apollo-audit.corp.amazon.com/audits/new?audit_type_id=4596"
              
          >
              Dispatch Sorting Situational Based Coaching 2x2x2 Apollo Audit
          </a>
      </span>
      <span
          style="
              -webkit-text-stroke-width: 0px;
              color: #212f3e;
              display: inline !important;
              float: none;
              font-family: Ember, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
              font-size: medium;
              font-style: normal;
              font-variant-caps: normal;
              font-variant-ligatures: normal;
              font-weight: 400;
              letter-spacing: normal;
              orphans: 2;
              text-align: start;
              text-decoration-color: initial;
              text-decoration-style: initial;
              text-decoration-thickness: initial;
              text-indent: 0px;
              text-transform: none;
              white-space: pre-wrap;
              widows: 2;
              word-spacing: 0px;
          "
      >
          (hold SHIFT before clicking the link to open in new window)
      </span>
      <br />
      2) After completing the Coaching, come back to the SCC Work Item and click the "Task Complete" Button in the bottom righthand corner of the SCC Work Item.
  </p>
  <p><strong>Supplemental Links</strong></p>
  <p>
      1)
      <span className="wikiexternallink">
          <a
              href="https://d26wfe7v40mam2.cloudfront.net/US_EN/Stow_StandardWork/story.html"
              data-toggle="tooltip"
              data-placement="top"
              title=""
              rel="nofollow noreferrer noopener"
              data-original-title="Warning: This is an external link to d26wfe7v40mam2.cloudfront.net"
          >
              Stow Standard Work Coaching
          </a>
      </span>
      <span
          style="
              -webkit-text-stroke-width: 0px;
              color: #212f3e;
              display: inline !important;
              float: none;
              font-family: Ember, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
              font-size: medium;
              font-style: normal;
              font-variant-caps: normal;
              font-variant-ligatures: normal;
              font-weight: 400;
              letter-spacing: normal;
              orphans: 2;
              text-align: start;
              text-decoration-color: initial;
              text-decoration-style: initial;
              text-decoration-thickness: initial;
              text-indent: 0px;
              text-transform: none;
              white-space: pre-wrap;
              widows: 2;
              word-spacing: 0px;
          "
      >
          (hold SHIFT before clicking the link to open in new window)
      </span>
      <br />
      2)
      <span className="wikiinternallink">
          <a
              href="https://us-east-1.quicksight.aws.amazon.com/sn/dashboards/3c512f1b-7832-4fe0-8cc9-69f72b8a31d4/sheets/3c512f1b-7832-4fe0-8cc9-69f72b8a31d4_e66b5c8d-8b84-4c83-8e05-4eb1c5a94c07?state=hashArgs%23&amp;isauthcode=true&amp;qs-signin-user-auth=false&amp;directory_alias=amzlbiaquicksight"
          >
              Learning Curve Dashboard
          </a>
      </span>
      <span
          style="
              -webkit-text-stroke-width: 0px;
              color: #212f3e;
              display: inline !important;
              float: none;
              font-family: Ember, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
              font-size: medium;
              font-style: normal;
              font-variant-caps: normal;
              font-variant-ligatures: normal;
              font-weight: 400;
              letter-spacing: normal;
              orphans: 2;
              text-align: start;
              text-decoration-color: initial;
              text-decoration-style: initial;
              text-decoration-thickness: initial;
              text-indent: 0px;
              text-transform: none;
              white-space: pre-wrap;
              widows: 2;
              word-spacing: 0px;
          "
      >
          (hold SHIFT before clicking the link to open in new window)
      </span>
      <br />
      3)
      <span className="wikiinternallink">
          <a
              href="https://us-east-1.quicksight.aws.amazon.com/sn/dashboards/8a3bc293-f000-4176-8ff9-efb2c520b711/sheets/8a3bc293-f000-4176-8ff9-efb2c520b711_19899375-ed94-4bae-be63-fb9e33721b2d"
          >
              UTRX Stow Scan Details Quicksight 
          </a>
      </span>
      <span
          style="
              -webkit-text-stroke-width: 0px;
              color: #212f3e;
              display: inline !important;
              float: none;
              font-family: Ember, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
              font-size: medium;
              font-style: normal;
              font-variant-caps: normal;
              font-variant-ligatures: normal;
              font-weight: 400;
              letter-spacing: normal;
              orphans: 2;
              text-align: start;
              text-decoration-color: initial;
              text-decoration-style: initial;
              text-decoration-thickness: initial;
              text-indent: 0px;
              text-transform: none;
              white-space: pre-wrap;
              widows: 2;
              word-spacing: 0px;
          "
      >
          (hold SHIFT before clicking the link to open in new window) - use the scan data to coach the associate on parts of the process in which they are deficient.
      </span>
      <br />
      4)
      <span className="wikiinternallink">
          <a
              href="https://w.amazon.com/bin/view/AMZL/Stow_Scan_Details/"
          >
              Stow Scan Details Wiki
          </a>
      </span>
      <span
          style="
              -webkit-text-stroke-width: 0px;
              color: #212f3e;
              display: inline !important;
              float: none;
              font-family: Ember, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
              font-size: medium;
              font-style: normal;
              font-variant-caps: normal;
              font-variant-ligatures: normal;
              font-weight: 400;
              letter-spacing: normal;
              orphans: 2;
              text-align: start;
              text-decoration-color: initial;
              text-decoration-style: initial;
              text-decoration-thickness: initial;
              text-indent: 0px;
              text-transform: none;
              white-space: pre-wrap;
              widows: 2;
              word-spacing: 0px;
          "
      >
          (hold SHIFT before clicking the link to open in new window) - Coaching best practices
      </span>
      <br />
      5)
      <span className="wikiinternallink">
          <a
              href="https://apollo-audit.corp.amazon.com/audits/new?audit_type_id=4596"
          >
              Dispatch Sorting Situational Based Coaching 2x2x2 Apollo Audit
          </a>
      </span>
      <span
          style="
              -webkit-text-stroke-width: 0px;
              color: #212f3e;
              display: inline !important;
              float: none;
              font-family: Ember, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
              font-size: medium;
              font-style: normal;
              font-variant-caps: normal;
              font-variant-ligatures: normal;
              font-weight: 400;
              letter-spacing: normal;
              orphans: 2;
              text-align: start;
              text-decoration-color: initial;
              text-decoration-style: initial;
              text-decoration-thickness: initial;
              text-indent: 0px;
              text-transform: none;
              white-space: pre-wrap;
              widows: 2;
              word-spacing: 0px;
          "
      >
          (hold SHIFT before clicking the link to open in new window)
      </span>
      
  </p>
</div>
`
);



// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_Stow_Standard_Work.jsx